/*
 Mirror the selected variant SKU into the address bar as `?sku=`.

 BigCommerce natively reads `?sku=` on a product page and preselects that
 variant, so keeping the parameter in sync turns the address bar into a
 copy-pasteable link to the exact configuration on screen. That matters on
 products whose parent is a placeholder and whose variants are the real items.

 While a selection is still incomplete the attribute endpoint answers with the
 parent product's SKU and no variantId, so variantId is what gates the write --
 using the SKU alone would publish the placeholder.
 */

const SKU_PARAM = 'sku';

export default function syncSkuUrl(sku, variantId) {
    if (typeof window.history.replaceState !== 'function') {
        return;
    }

    const variantSku = variantId && sku ? sku : '';
    const params = new URLSearchParams(window.location.search);

    if (variantSku === (params.get(SKU_PARAM) || '')) {
        return;
    }

    if (variantSku) {
        params.set(SKU_PARAM, variantSku);
    } else {
        params.delete(SKU_PARAM);
    }

    const queryString = params.toString();
    const url = queryString
        ? `${window.location.pathname}?${queryString}`
        : window.location.pathname;

    window.history.replaceState(null, document.title, url);
}
